<template>

    <div class="page_content module_course" aria-label="Grading Page Content" v-if="permission && permission.version === '5'">

        <course-header :course-id="course.uuid" class="header_course_dashboard"></course-header>

        <div class="row page-content grading">



            <div class="col-11 dasboard-left-section report-Page">
                <div class="col-12">

                  <div class="section_head hd_bdr ace_sec_hd" role="heading" aria-level="2">{{course.title}} > Ready For Grading</div>

                  <b-row v-if="showManualGradingView">
                      <manual-grading :data="manualGradingParameter" @saveScore="afterSaveScore"></manual-grading>
                  </b-row>

                  <b-row v-else>
                    <span v-if="(attempts.length === 0)" style="padding-left: 20px;" class="ace_sec_txt">No Attempts to be graded</span>
                    <template v-else>

                        <table class="grading">
                          <thead>
                            <tr>
                                <th class="user-column ace_sec_txt"> Name </th>
                                <th class="attempt-column ace_sec_txt"> KC to be Graded </th>
                                <th class="last-column ace_sec_txt"> Date and Time of Attempt </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="attempt in attempts">
                                <td class="user-column ace_sec_txt">
                                	<span class="icon-user"></span>
                                	<span class="usr_name ace_sec_txt">{{attempt.name}}</span>
                                </td>
                                <td class="attempt-column">
									<div class="kc-grade-column">
										<span class="kc_attampt ace_sec_txt" :title="attempt.title">{{attempt.title}}</span>
										<b-button size="sm" @click.stop="openManualGrading(attempt)" class="btn_2" aria-label="grade" :disabled="permission.systemPermission.readOnly">grade</b-button>
									</div>
                                </td>
                                <td class="last-column ace_sec_txt">{{getFormattedDateTime(attempt.submissionTime)}}</td>
                            </tr>
                          </tbody>
                        </table>
                    </template>
                  </b-row>
                </div>
            </div>

        </div>
   </div>

</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import ManualGrading from '../../assessment/components/ManualGrading'

export default {
  name: 'grading',
  props: ['uuid', 'title', 'users'],
  components: {
    CourseNav,
    CourseHeader,
    ManualGrading
  },

  data: () => {
    return {
      manualGradingParameter: {},
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      assessmentIds: [],
      attempts: [],
      showManualGradingView: false
    }
  },

  watch: {
  },

  mounted () {
    this.loadPermission().then(res => {
      this.loadCourse()
    })
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadCourseTopics',
      'loadUngradedAttempts',
      'loadFullClassSummary',
      'loadPermission'
    ]),

    setBreadcrumbWidth () {
      if ((this.breadcrumbItems.length) === 1) {
        $('.breadcrumb').addClass('first-level')
        $('.breadcrumb').removeClass('second-level third-level fourth-level')
      } else if ((this.breadcrumbItems.length) === 2) {
        $('.breadcrumb').addClass('second-level')
        $('.breadcrumb').removeClass('first-level third-level fourth-level')
      } else if ((this.breadcrumbItems.length) === 3) {
        $('.breadcrumb').addClass('third-level')
        $('.breadcrumb').removeClass('second-level first-level fourth-level')
      } else if ((this.breadcrumbItems.length) === 4) {
        $('.breadcrumb').addClass('fourth-level')
        $('.breadcrumb').removeClass('second-level first-level third-level')
      }
    },

    calculateAndShowTimeTaken (timeTaken) {
      return this.msToTime(timeTaken)
    },

    msToTime (timeTaken) {
      if (timeTaken < 1) {
        return 'N/A'
      }

      var ms = timeTaken % 1000
      timeTaken = (timeTaken - ms) / 1000
      var secs = timeTaken % 60
      timeTaken = (timeTaken - secs) / 60
      var mins = timeTaken % 60
      var hrs = (timeTaken - mins) / 60
      if (hrs < 10) {
        hrs = '0' + hrs
      }
      if (mins < 10) {
        mins = '0' + mins
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return hrs + ':' + mins + ':' + secs
    },

    getFormattedDateTime (timeInMillis, showOnlyDate) {
      if (timeInMillis === 0) {
        return 'N/A'
      }
      var d
      var str = ''
      d = new Date(timeInMillis)
      str += String(this.months[d.getMonth()])
      str += ' ' + d.getDate()
      str += ', ' + d.getFullYear()
      if (!showOnlyDate) {
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        var currSec = d.getSeconds()
        currSec = currSec + ''
        if (currSec.length === 1) {
          currSec = '0' + currSec
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ':' + currSec
        str += ' ' + amPm
      }
      return str
    },

    loadCourse () {
      this.loadCourseDetail(this.uuid)
      this.loadFullClassSummary({courseId: this.uuid, loadDataFromServer: true}).then(result => {
        var i = 0
        for (i = 0; i < this.fullClassSummary.length; i++) {
          if (this.fullClassSummary[i].competencyType === 'ASSESSMENT') {
            this.assessmentIds.push(this.fullClassSummary[i].entityId)
          }
        }
        this.loadUngradedAttempts(this.assessmentIds).then(response => {
          this.attempts = response
        })
        /*
        this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true}).then(res => {
          var i = 0
          for (i = 0; i < this.linearTopics.length; i++) {
            if (this.linearTopics[i].objectType === 'LearningContent' && this.linearTopics[i].fileType === 'assessment') {
              this.assessmentIds.push(this.linearTopics[i].uuid)
            }
          }
          this.loadUngradedAttempts(this.assessmentIds).then(response => {
            this.attempts = response
          })
        })
        */
      })
    },

    scrollTable () {
      var tableRowContainer = $('.table_row_container')
      var tableRowHeader = $('.table_row_header')
      var tableFirstCol = $('.table_first_col')

      tableRowHeader.scrollLeft(tableRowContainer.scrollLeft())
      tableFirstCol.scrollTop(tableRowContainer.scrollTop())
    },

    scrollTableHorizontal () {
      var tableRowContainer = $('.table_row_container')
      var tableRowHeader = $('.table_row_header')

      tableRowContainer.scrollLeft(tableRowHeader.scrollLeft())
    },

    openManualGrading (attempt) {
      this.showManualGradingView = true
      this.manualGradingParameter['name'] = attempt.name
      this.manualGradingParameter['userId'] = attempt.userId
      this.manualGradingParameter['sessionId'] = attempt.sessionId
      this.manualGradingParameter['activityId'] = attempt.activityId
      this.manualGradingParameter['manualGradingRubricPdfUri'] = attempt.manualGradingRubricPdfUri
    },

    afterSaveScore () {
      this.$router.go({
        path: this.$router.path,
        query: {
          t: new Date().getTime()
        }
      })
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'linearTopics': state => state.course.linearTopics,
      'fullClassSummary': state => state.course.fullClassSummary,
      'permission': state => state.user.permission
    })
  }
}
</script>

<style scoped>
.course-nav {
    background:#e1e1e1;
    min-height: 500px;
}
.coure-nav-list-item {
    background:#e1e1e1;
    border: none;
}

.course-thumbnail {
    background:#f8f9fa;
    min-height: 500px;
}

.course-information {
    margin-top:20px;
}

.course-description {
    padding-top:20px;
}

.activity-row {
    padding-top:20px;
}

.card {
    border: none!important;
}

.card-header {
    background: rgb(245, 245, 245) !important;
}

.card-body {
    background: rgb(245, 245, 245) !important;
}

.report-Page .heading {
    padding: 7px 7px 7px 7px;
    border-bottom: 1px solid #efefef;
    font-size: 20px;
    font-family: robotoSlab_Light;
    margin-bottom:15px;
}
.report-Page {
    padding-top:18px;
}
.report-Page .activity-graph-container {
    border: 1px solid #dbdbdb!important;
    border-radius: 0;
    min-height: 270px;
    font-family: openSans_Regular;
}

.report-Page .label {
    background: #c9e0b2;
    padding: 8px;
    color: #4d4d4d;
    font-size: 19px;
}

.report-Page .graph-area {
    height: 228px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.graph-min-height {
    min-height:251px!important;
}

.report-Page .graph-text {
    text-align: center;
    color: #4d4d4d;
    position: relative;
    top: -42px;
}
.report-Page .dashboard-row {
    min-width:1115px;
    padding-left:15px;
}
.report-Page .left-space {
    padding-left:100px;
}
.report-section {
    height: auto;
    padding-left: 15px;
}

.report-graph {
    flex: 0 0 30%!important;
    max-width: 30%!important;
}

.competency-details-row {
    padding-left:33px;
    height: auto;
}

.competency-details-row .value, .competency-details-row .title {
    width: 100%;
    float: left;
    padding: 8px 8px;
}

.score-column {
    width: 30%;
    display: none;
    margin-top: 15px;
}

.column.progress-column {
    position: relative !important;
    display: none;
    margin-top: 9px;
    padding-top: 0!important;
    padding-bottom: 0!important;
    padding-left: 10px!important;
}

.time-column {
    width: 30%;
    display: none;
}

.column.time-column, .column.resource-time-column {
   height: 44px;
   padding: 0!important;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 9px;
   background: none;
}

.time-value-box {
    padding:10px 15px;
    background:rgb(143, 143, 143);
    color:#fff;
	width:96px;
	text-align:center;
}

.last-activity-value-box {
    padding: 5px 8px;
    background: #8f8f8f;
    color: #fff;
    position: absolute;
    font-size: 12px;
    top: 9px;
    height: 44px;
    width: 94px;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.resource-time-column {
    position:relative;
    display: none;
}

.last-activity-column {
    position:relative;
    display: none;
}

.competency_progress {
    width:100%;
    position:static;
}

.table thead {
    background: #f5f5f5;
}

.report-column {
	height:calc(100vh - 290px);
	overflow-y: hidden;
	overflow-x: hidden;
}

.breadcrumb-item {
	max-width: 195px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@media (max-width: 1024px) {
	.report-column {
		overflow-y:auto;
	}
}

button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
}

.attempt-report-close {
    float: right;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}


</style>



// WEBPACK FOOTER //
// src/app/course/components/Grading.vue